import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LandingPage from "@/pages/LandingPage";
import SilvesterBooking from "@/pages/SilvesterBooking";
import EisstockBooking from "@/pages/EisstockBooking";
import Datenschutz from "@/pages/Datenschutz";
import Impressum from "@/pages/Impressum";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import CheckInPage from "@/pages/CheckInPage";
import MusikUndMeer from "@/pages/MusikUndMeer";
import GutscheinBooking from "@/pages/GutscheinBooking";
import GutscheinWiderruf from "@/pages/GutscheinWiderruf";
import Eisstockregeln from "@/pages/Eisstockregeln";
import AGB from "@/pages/AGB";
import TagesplanPage from "@/pages/TagesplanPage";
import PayPage from "@/pages/PayPage";
import StaffLogin from "@/pages/staff/StaffLogin";
import StaffHub from "@/pages/staff/StaffHub";
import StaffTagesplan from "@/pages/staff/StaffTagesplan";
import StaffSchichtbericht from "@/pages/staff/StaffSchichtbericht";
import { Navigate } from "react-router-dom";
import CookieConsent from "@/components/CookieConsent";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/silvester" element={<SilvesterBooking />} />
          <Route path="/eisstock" element={<EisstockBooking />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/checkin" element={<CheckInPage />} />
          <Route path="/musik-und-meer" element={<MusikUndMeer />} />
          <Route path="/gutschein" element={<GutscheinBooking />} />
          <Route path="/gutschein/widerruf" element={<GutscheinWiderruf />} />
          <Route path="/eisstockregeln" element={<Eisstockregeln />} />
          <Route path="/agb" element={<AGB />} />
          <Route path="/admin/tagesplan" element={<TagesplanPage />} />
          <Route path="/pay/:type/:id" element={<PayPage />} />

          {/* Staff (Mitarbeiter) App */}
          <Route path="/staff/login" element={<StaffLogin />} />
          <Route path="/staff" element={<StaffHub />} />
          <Route path="/staff/scanner" element={<Navigate to="/checkin" replace />} />
          <Route path="/staff/tagesplan" element={<StaffTagesplan />} />
          <Route path="/staff/schichtbericht" element={<StaffSchichtbericht />} />
        </Routes>
        <CookieConsent />
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
